export async function HandleLogout(navigate, logout) {
    try {
      await logout()
      navigate('/login');
    }
    catch(err) {
      console.log(err);
    }
  }